import { writable } from 'svelte/store'

function createStore() {
    const { subscribe, set } = writable({
        media: [
            { name: '', loop: false },
            { name: '', loop: false },
            { name: '', loop: false },
            { name: '', loop: false },
            { name: '', loop: false },
        ],
    })

    return {
        subscribe,
        set: (data) => {
            set(data)
        },
    }
}

export const configStore = createStore()
